import React from 'react'
import Marquee from "react-fast-marquee";
import { ReactComponent as Gmail } from '../images/gmail.svg';
import { ReactComponent as Linkedin } from '../images/linkedin.svg';
import { ReactComponent as Twitter } from '../images/twitterColor.svg';
const Footer = () => {
    return (
        <footer>
            <div className="container footerContainer">
                <h5>Let's connect 🤗</h5>
                <p>I’m always happy 😊 to make new friends, face new challenges 💪🏾,
                    <br />
                    and have some fun. Feel free to reach out</p>
            </div>
            <Marquee gradient={false} speed={100} pauseOnHover={true}>
                <h1 className="marqueeText"> LET’S TALK — LET’S COLLABORATE — LET’S BUILD - LET’S INNOVATE - </h1>
            </Marquee>
            <div className="container linkContainer">
                <a href='mailto:oyekunlesodiq7@gmail.com' className='footerLinkIcon'>
                    <Gmail />
                </a>
                <a href='https://www.linkedin.com/in/sodiq-azeez-fs' className='footerLinkIcon'>
                    <Linkedin />
                </a>
                <a href='https://twitter.com/Koreydesh' className='footerLinkIcon'>
                    <Twitter />
                </a>
            </div>
        </footer>
    )
}

export default Footer